import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { GeneralState, initialStoreState } from './general.model';
import {
  AttributeDto,
  AttributeOperatorViewWithOperatorAttributeSettingsDto,
  OperatorAttributeDto,
} from '../../core/models/attribute-dto';
import { ErpDto } from '../../core/models/erp-dto';
import { OperatorDto } from '../../core/models/operator';
import { OrgUnitDto } from '../../core/models/org-unit-dto';
import { StockQuantityChangeReasonDto } from '../../core/models/stock-quantity-change-reason-dto';
import { UnitOfMeasureDto } from '../../core/models/unit-of-measure-dto';
import { UserDto } from '../../core/models/user-dto';
import { TreeNode } from '../../core/tree.utils';

export interface GState extends EntityState<GeneralState, number> {}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'general' })
export class GeneralStore extends EntityStore<GState> {
  constructor() {
    super(initialStoreState);
  }

  setOperatorUsers(operatorUsers: UserDto[]) {
    this.update({ operatorUsers });
  }

  setOrgUnits(orgUnits: TreeNode<OrgUnitDto>) {
    this.update({ orgUnits });
  }

  setAttributeList(attributes: OperatorAttributeDto[]) {
    this.update({ attributes });
  }

  setReductionReasons(stockReductionReasons: StockQuantityChangeReasonDto[]) {
    this.update({ stockReductionReasons });
  }

  setOperatorData(operator: OperatorDto) {
    this.update({ operator });
  }

  setUnitOfMeasure(unitOfMeasure: UnitOfMeasureDto[]) {
    this.update({ unitOfMeasure });
  }

  setCurrencies(currencies: string[]) {
    this.update({ currencies });
  }

  setOperatorErp(erps: ErpDto[]) {
    this.update({ erps });
  }

  setIsOperatorMultiErp(isOperatorMultiErp: boolean) {
    this.update({ isOperatorMultiErp });
  }

  setHasCaAccess(hasCaAccess: boolean) {
    this.update({ hasCaAccess });
  }

  setHasSmAccess(hasSmAccess: boolean) {
    this.update({ hasSmAccess });
  }

  setHasPlanAccess(hasPlanAccess: boolean) {
    this.update({ hasPlanAccess });
  }

  setHasPoolAccess(hasPoolAccess: boolean) {
    this.update({ hasPoolAccess });
  }

  setIsUserManager(isUserManager: boolean) {
    this.update({ isUserManager });
  }

  setCatalogueAttributes(catalogueAttributes: AttributeDto[]) {
    this.update({ catalogueAttributes });
  }

  setOperatorAttributePermission(operatorAttributePermission: AttributeOperatorViewWithOperatorAttributeSettingsDto[]) {
    this.update({ operatorAttributePermission });
  }
}
